module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: "modalOperation",
    on: {
      "input": _vm.closeInput
    }
  }, [_c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('a', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preset),
      expression: "preset"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.usePreset($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Use preset...")]), _vm._l((_vm.presets), function(i, k) {
    return _c('option', {
      key: k,
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(k) + ": " + _vm._s(i.description))])
  })], 2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jsonOperation),
      expression: "jsonOperation"
    }],
    staticStyle: {
      "font-family": "monospace"
    },
    attrs: {
      "rows": "10",
      "placeholder": "Paste your Json Operation"
    },
    domProps: {
      "value": (_vm.jsonOperation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.jsonOperation = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    ref: "file",
    staticClass: "input-group-field",
    attrs: {
      "type": "file"
    }
  }), _c('div', {
    staticClass: "input-group-button"
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled || _vm.spin,
      "value": "Upload"
    },
    on: {
      "click": _vm.handleFile
    }
  }, [(_vm.spin) ? _c('span', {
    staticClass: "fa fa-spinner fa-spin",
    class: {
      spin: _vm.spin
    }
  }) : _c('span', [_vm._v("Upload")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.doOperation,
      "disabled": _vm.jsonOperation == ''
    }
  }, [_vm._v("Run")])], 1)])]), _c('div', {
    staticClass: "component-backoffice-cargo-list row column"
  }, [_c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41b61fff!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/Cargo.vue
// module id = 2379
// module chunks = 1